var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0 px-0"},[_c('v-col',{staticClass:"px-1 py-1 mt-2 mb-5 pb-5"},[_c('information')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }